import Loadable from '@townsquare/loadable';

export const ProjectsApp = Loadable({
	loader: () => import(/* webpackChunkName: "projects-app-entry" */ '@townsquare/projects/app'),
	loading: () => null,
});
